module.exports = __webpack_public_path__ + "static/media/features-5.d639f4d6.jpg";